<template>
  <nav class="ops-tabs" aria-label="업무 화면">
    <button
      type="button"
      class="ops-tab"
      :class="{ active: active === 'ops' }"
      @click="open('managertnbox.dashboard')"
    >
      <v-icon class="ops-tab-icon">mdi-chart-timeline-variant</v-icon>
      <span class="ops-tab-copy">
        <strong>업무 현황</strong>
        <em>전체 합계와 월별 추이</em>
      </span>
    </button>
    <button
      type="button"
      class="ops-tab"
      :class="{ active: active === 'rank' }"
      @click="open('managertnbox.dashboard.rank')"
    >
      <v-icon class="ops-tab-icon">mdi-podium</v-icon>
      <span class="ops-tab-copy">
        <strong>업체 비교</strong>
        <em>업체 검색과 기간 순위</em>
      </span>
    </button>
  </nav>
</template>

<script>
export default {
  name: "OpsViewTabs",
  computed: {
    active() {
      return this.$route.name === "managertnbox.dashboard.rank" ? "rank" : "ops"
    },
  },
  methods: {
    open(name) {
      if (this.$route.name === name) return
      this.$router.push({name: name})
    },
  },
}
</script>

<style scoped>
.ops-tabs {
  display: flex;
  gap: 8px;
  padding: 4px;
  background: #eef2f6;
  border-radius: 14px;
}
.ops-tab {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 196px;
  padding: 8px 14px;
  border: 0;
  border-radius: 11px;
  background: transparent;
  color: #475467;
  cursor: pointer;
  text-align: left;
}
.ops-tab.active {
  background: #fff;
  color: #0f766e;
  box-shadow: 0 1px 2px rgba(16, 24, 40, 0.08);
}
.ops-tab-icon {
  color: inherit;
}
.ops-tab-copy {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}
.ops-tab-copy strong {
  font-size: 15px;
}
.ops-tab-copy em {
  font-style: normal;
  font-size: 12px;
  color: #667085;
}
.ops-tab.active .ops-tab-copy em {
  color: #0f766e;
}
</style>
